"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenNotify = listenNotify;
const events_1 = require("@front/event/events");
function listenNotify() {
    this.on(events_1.appEvents.removeNotify, (event) => {
        this.notifications = this.notifications.filter((item, itemIndex) => itemIndex !== event.detail.index);
    });
    this.on(events_1.appEvents.removeNotifyById, (event) => {
        this.notifications = this.notifications.filter((item, itemIndex) => item.id !== event.detail.id);
    });
    this.on(events_1.appEvents.notify, (event) => {
        this.notifications = [...this.notifications, event.detail];
    });
}
